import BaseModel from './BaseModel';
import FileModel from './FileModel';

export default class DriverCertificationModel extends BaseModel {
  init(data) {
    this.id = data.id || 0;
    this.certification_type = data.certification_type || '';
    this.certification_name = data.certification_name || '';
    this.expiration = data.expiration || null;
    this.document = data.document || null;
    this.attachments = (data.attachments || []).map(a => new FileModel(a));
    this.created = data.created || null;
    this.updated = data.updated || null;
  }
}
